import { memo } from "react";
import { PurchaseStepE } from "../../../../models/enums";
import usePurchases from "../../../../hooks/usePurchases";
import Icon from "../../../../../../Elements/Icon/Icon";
import { useContent } from "../../../../../../../contexts/contentContext/contentContext";

import styles from "./styles.module.scss";

const BackButton = memo(() => {
  const { getDirection, getTextByKey } = useContent();
  const { completedStep, setCompletedStep } = usePurchases();

  return completedStep < PurchaseStepE.THIRD_PAYMENT_STEP ? (
    <div
      className={styles.backButton}
      onClick={() => setCompletedStep(PurchaseStepE.FIRST_PURCHASE_METHOD_STEP)}
    >
      <span
        className={`${styles.backImg} ${
          getDirection() === "rtl" ? styles.backImgRtl : ""
        }`}
      >
        <Icon name="arrow-back" darkGray />
      </span>
      <span>{getTextByKey("back-text")}</span>
    </div>
  ) : null;
});

export default BackButton;
